<template>
  <SettingCard class="setting-property-item" :is-open="isOpened" @accordion="accordionToggle" @save="onClickSave">
    <template v-slot:title>
      物件データ表示項目設定
    </template>
    <template v-slot:notice>
      ユーザー毎にヘッダー項目の順番の入れ替え、出し入れができます。
    </template>

    <template v-slot:contents>
      <div>
        <p>一覧に表示したい項目セルの設定を行います。</p>
        <ul class="list">
          <li>・「表示する項目」の「ー」ボタンを押すことで一覧からは非表示にすることができます。</li>
          <li>・「表示しない項目」の「＋」ボタンを押すことで一覧に表示することができます。</li>
          <li>
            ・「表示する項目」の「三」をドラッグアンドドロップすることで、表示順番の入れ替えができます。（最上部が左に表示）
          </li>
        </ul>

        <div class="contents">
          <div style="padding-right: 4px;">
            <h3>表示する項目</h3>
            <draggable v-model="displayList" :element="'table'" v-bind="dragOptions" class="table">
              <transition-group tag="tbody" class="list" name="list">
                <tr v-for="item in displayList" :key="item.column_id" class="list-item">
                  <td>
                    <i-icon type="ios-remove-circle" size="20" class="ico_delete" @click="onClickDelete(item)" />
                    {{ item.name }}
                    <i-icon type="ios-list" size="28" />
                  </td>
                </tr>
              </transition-group>
            </draggable>
          </div>

          <div style="padding-left: 4px;">
            <h3>表示しない項目</h3>
            <draggable v-model="deleteList" :element="'table'" class="table">
              <transition-group tag="tbody" class="list" name="list">
                <tr v-for="item in deleteList" :key="item.column_id" class="list-item">
                  <td>
                    <i-icon type="ios-add-circle" size="20" class="ico_add" @click="onClickAdd(item)" />
                    {{ item.name }}
                    <i-icon type="ios-list" size="28" />
                  </td>
                </tr>
              </transition-group>
            </draggable>
          </div>
        </div>
      </div>
    </template>
  </SettingCard>
</template>

<script>
// @docs https://github.com/SortableJS/Vue.Draggable
import draggable from 'vuedraggable'
import { Icon } from 'view-design'
import SettingCard from '@/components/parts/SettingCard'
import SettingRepository from '@/repositories/settingRepository'
export default {
  components: {
    draggable,
    'i-icon': Icon,
    SettingCard,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
      requied: true,
    },
    type: {
      type: String,
      default: '',
      required: true,
      validator: function(value) {
        return ['investment', 'residence'].indexOf(value) !== -1
      },
    },
  },
  data() {
    return {
      isOpened: false,
      displayList: [],
      deleteList: [],
      dragOptions: {
        disabled: false,
      },
    }
  },
  computed: {},
  methods: {
    // アコーディオン 開閉処理
    accordionToggle: function() {
      if (!this.isOpened) {
        this.init()
      } else {
        this.isOpened = false
        this.resetParams()
      }
    },
    // 表示処理
    init() {
      const column = _.cloneDeep(this.$store.getters['Column/getColumns'])
      // 表示項目と非表示項目データを生成
      const displayList = []
      const deleteList = []
      _.forEach(column, item => {
        let displayItem = item
        let text = _.find(this.columns, { cd: `display${item.column_id}` })
        displayItem.name = text.name
        if (item.f_display) {
          displayList.push(displayItem)
        } else {
          deleteList.push(displayItem)
        }
      })

      this.displayList = displayList
      this.deleteList = deleteList

      this.isOpened = true
    },
    // 項目非表示設定
    onClickDelete(item) {
      this.dragOptions.disabled = true
      item.f_display = 0
      _.remove(this.displayList, function(list) {
        return list.column_id === item.column_id
      })
      this.deleteList.push(item)
      this.dragOptions.disabled = false
    },
    // 項目表示設定
    onClickAdd(item) {
      this.dragOptions.disabled = true
      item.f_display = 1
      _.remove(this.deleteList, function(list) {
        return list.column_id === item.column_id
      })
      this.displayList.push(item)
      this.dragOptions.disabled = false
    },
    // 保存ボタン クリック処理
    onClickSave() {
      this.$store.dispatch('Loading/setLoading', true)

      // 登録用のパラメータを作成
      const columns = this.displayList.concat(this.deleteList)

      // 表示テキストnameを削除 order_no生成
      const params = []
      _.forEach(columns, (item, key) => {
        let param = {
          column_id: item.column_id,
          f_display: item.f_display,
          order_no: key + 1,
        }
        params.push(param)
      })

      this.putColumns(params, this.type)
    },
    // 設定登録処理
    async putColumns(params, type) {
      await SettingRepository.putColumns(params, type)
        .then(data => {
          if (data.result) {
            this.$store.commit('Column/setColumns', params)
            alert('項目設定を更新しました。')
          } else {
            alert('項目設定の更新に失敗しました。')
          }
        })
        .catch(e => {
          console.log(e)
          alert('項目設定の更新に失敗しました。')
        })
        .finally(() => {
          this.$store.dispatch('Loading/setLoading', false)
        })
    },
    // パラメーターリセット
    resetParams() {
      this.displayList = []
      this.deleteList = []
    },
  },
}
</script>

<style lang="scss" scoped>
.setting-property-item {
  .list {
    list-style: none;
    margin-bottom: 16px;
  }
  .contents {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    min-height: 620px;
  }
  .table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    margin-bottom: 32px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    tr {
      border: 1px solid #cfcfcf;
    }
    td {
      padding: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 10px;
      font-weight: bold;
    }
  }

  .list {
    list-style: none;
    &-item {
      padding: 4px;
      border: 1px solid #cfcfcf;
      cursor: pointer;
    }
  }
  .ico_delete {
    color: #ed4014;
  }
  .ico_add {
    color: #19be6b;
  }
}
</style>
